import { render, staticRenderFns } from "./SenetAlacakForm.vue?vue&type=template&id=a665fb46"
import script from "./SenetAlacakForm.vue?vue&type=script&lang=ts"
export * from "./SenetAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports